// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jgp-3RbvD","skeleton":"jgp-1cK36"};